import { gql } from '@apollo/client';

export const UPSERT_CASE_MANAGEMENT = gql`
  mutation upsertCaseManagement($input: UpsertCaseManagementInput!) {
    caseManagement: upsertCaseManagement(input: $input) {
      id
    }
  }
`;
